"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContentReplicator = void 0;
var replicator_1 = require("./replicator");
Object.defineProperty(exports, "createContentReplicator", { enumerable: true, get: function () { return replicator_1.createContentReplicator; } });
//# sourceMappingURL=index.js.map